import { NgModule } from '@angular/core';
import { ValidateEqualDirective } from './ng-validate-equal.directive';



@NgModule({
  declarations: [ValidateEqualDirective],
  imports: [],
  exports: [ValidateEqualDirective]
})
export class ValidateEqualModule { }
